export default __webpack_public_path__ + "static/media/event-tutorial.7387c1f1.png";